import Layout from '@/components/layout/index.vue';
import Welcome from '@/pages/welcome/index.vue';
import Login from '@/pages/login/index.vue';
import { useLayoutStore } from '@/store';
function getProps(route) {
    return route.query;
}
// 系统生成路由
export const routers = [
    {
        path: '/login',
        component: Login,
        name: 'login',
        meta: {
            title: '登录',
        },
    },
    {
        path: '/',
        component: Layout,
        name: 'main',
        props: getProps,
        redirect: {
            name: 'welcome',
        },
        meta: {
            title: '主页',
            showOnly: true,
        },
        children: [
            {
                path: 'welcome',
                component: Welcome,
                name: 'welcome',
                meta: { title: '欢迎' },
            },
            {
                path: 'formSysMenu',
                component: () => useLayoutStore().supportColumn
                    ? import('@/pages/upms/formSysMenu/formSysColumnMenu.vue')
                    : import('@/pages/upms/formSysMenu/index.vue'),
                name: 'formSysMenu',
                meta: { title: '菜单列表' },
            },
            {
                path: 'formSysUser',
                component: () => import('@/pages/upms/formSysUser/index.vue'),
                name: 'formSysUser',
                meta: { title: '用户列表' },
            },
            {
                path: 'formSysOrganization',
                component: () => import('@/pages/upms/formSysOrganization/index.vue'),
                name: 'formSysOrganization',
                meta: { title: '机构列表' },
            },
            {
                path: 'formSysDepartment',
                component: () => import('@/pages/upms/formSysDepartment/index.vue'),
                name: 'formSysDepartment',
                meta: { title: '部门管理' },
            },
            {
                path: 'formSysRole',
                component: () => import('@/pages/upms/formSysRole/index.vue'),
                name: 'formSysRole',
                meta: { title: '角色管理' },
            },
            {
                path: 'formSysDataPerm',
                component: () => import('@/pages/upms/formSysDataPerm/index.vue'),
                name: 'formSysDataPerm',
                meta: { title: '数据权限管理' },
            },
            {
                path: 'formSysPermCode',
                component: () => import('@/pages/upms/formSysPermCode/index.vue'),
                name: 'formSysPermCode',
                meta: { title: '权限字管理' },
            },
            {
                path: 'formSysPerm',
                component: () => import('@/pages/upms/formSysPerm/index.vue'),
                name: 'formSysPerm',
                meta: { title: '权限资源管理' },
            },
            {
                path: 'formSysLoginUser',
                component: () => import('@/pages/upms/formSysLoginUser/index.vue'),
                name: 'formSysLoginUser',
                meta: { title: '在线用户' },
            },
            {
                path: 'formSysDict',
                component: () => import('@/pages/upms/formSysDict/index.vue'),
                name: 'formSysDict',
                meta: { title: '字典管理' },
            },
            {
                path: 'formSysOperationLog',
                component: () => import('@/pages/upms/formSysOperationLog/index.vue'),
                name: 'formSysOperationLog',
                meta: { title: '操作日志' },
            },
            {
                path: 'formExceptionLog',
                component: () => import('@/pages/upms/formExceptionLog/index.vue'),
                name: 'formExceptionLog',
                meta: { title: '异常日志' },
            },
            {
                path: 'formExport',
                component: () => import('@/pages/decl/formExport/index.vue'),
                name: 'formExport',
                meta: { title: '出口报关单' },
            },
            {
                path: 'formCustomsDoc',
                component: () => import('@/pages/decl/formCustomsDoc/index.vue'),
                name: 'formCustomsDoc',
                meta: { title: '报关单工作台' },
            },
            {
                path: 'formEditExport',
                component: () => import('@/pages/decl/formEditExport/index.vue'),
                name: 'formEditExport',
                meta: { title: '出口报关单编辑' },
            },
            {
                path: 'formImport',
                component: () => import('@/pages/decl/formImport/index.vue'),
                name: 'formImport',
                meta: { title: '进口报关单' },
            },
            {
                path: 'formEditImport',
                component: () => import('@/pages/decl/formEditImport/index.vue'),
                name: 'formEditImport',
                meta: { title: '进口报关单编辑' },
            },
            //仓库管理
            {
                path: 'formWarehouse',
                component: () => import('@/pages/cr/warehouse/formWarehouse/index.vue'),
                name: 'formWarehouse',
                meta: { title: '仓库管理' },
            },
            // 客戶关系管理
            // 客户关系管理-客户管理
            {
                path: 'formCustomer',
                component: () => import('@/pages/cr/customer/formCustomer/index.vue'),
                name: 'formCustomer',
                meta: { title: '客户管理' },
            },
            // 保税区管理
            // 保税区管理-申报组合管理
            {
                path: 'formDclGroup',
                component: () => import('@/pages/bonded/dclGroup/formDclGroup/index.vue'),
                name: 'formDclGroup',
                meta: { title: '申报组合管理' },
            },
            // 保税区管理-账册管理
            {
                path: 'formBondedBook',
                component: () => import('@/pages/bonded/bondedBook/formBondedBook/index.vue'),
                name: 'formBondedBook',
                meta: { title: '账册管理' },
            },
            {
                path: 'formBondedBookGoods',
                component: () => import('@/pages/bonded/bondedBook/formBondedBookGoods/index.vue'),
                name: 'formBondedBookGoods',
                meta: { title: '账册商品明细' },
            },
            // 保税区管理-保税入仓业务交接单
            {
                path: 'formInboundBill',
                component: () => import('@/pages/bonded/inboundBill/formInboundBill/index.vue'),
                name: 'formInboundBill',
                meta: { title: '保税入仓业务单' },
            },
            {
                path: 'formEditInboundBill',
                component: () => import('@/pages/bonded/inboundBill/formEditInboundBill/index.vue'),
                name: 'formEditInboundBill',
                meta: { title: '保税入仓业务单' },
            },
            {
                path: 'formInboundBillPallet',
                component: () => import('@/pages/bonded/inboundBill/formInboundBillPallet/index.vue'),
                name: 'formInboundBillPallet',
                meta: { title: '标签打印', hidden: true },
            },
            {
                path: 'formInboundBillForecast',
                component: () => import('@/pages/bonded/inboundBill/formInboundBillForecast/index.vue'),
                name: 'formInboundBillForecast',
                meta: { title: '进仓预报', hidden: true },
            },
            {
                path: 'formInboundBillPalletItem',
                component: () => import('@/pages/bonded/inboundBill/formInboundBillPallet/palletItem.vue'),
                name: 'formInboundBillPalletItem',
                meta: { title: '箱号信息', hidden: true },
            },
            // 保税区管理-仓库账册
            {
                path: 'formWarehouseBook',
                component: () => import('@/pages/bonded/inboundBill/formWarehouseBook/index.vue'),
                name: 'formWarehouseBook',
                meta: { title: '仓库账册' },
            },
            // 保税区管理-进口保税核注清单
            {
                path: 'formInvt',
                component: () => import('@/pages/bonded/invt/formInvt/index.vue'),
                name: 'formInvt',
                meta: { title: '进口保税核注清单' },
            },
            {
                path: 'formEditInvt',
                component: () => import('@/pages/bonded/invt/formEditInvt/index.vue'),
                name: 'formEditInvt',
                meta: { title: '进口保税核注清单' },
            },
            // 保税区管理-清单账册商品
            {
                path: 'formInvtBookGoods',
                component: () => import('@/pages/bonded/invt/formInvtBookGoods/index.vue'),
                name: 'formInvtBookGoods',
                meta: { title: '清单账册' },
            },
            // 保税区管理-入仓单入区核放单
            {
                path: 'formPassPort',
                component: () => import('@/pages/bonded/passPort/formPassPort/index.vue'),
                name: 'formPassPort',
                meta: { title: '核放单' },
            },
            {
                path: 'formEditPassPort',
                component: () => import('@/pages/bonded/passPort/formEditPassPort/index.vue'),
                name: 'formEditPassPort',
                meta: { title: '核放单编辑' },
            },
            // 保税区管理-出仓计划
            {
                path: 'formOutboundPlan',
                component: () => import('@/pages/bonded/outboundPlan/formOutboundPlan/index.vue'),
                name: 'formOutboundPlan',
                meta: { title: '出仓计划' },
            },
            {
                path: 'formEditOutboundPlan',
                component: () => import('@/pages/bonded/outboundPlan/formEditOutboundPlan/index.vue'),
                name: 'formEditOutboundPlan',
                meta: { title: '出仓计划编辑' },
            },
            {
                path: 'formPickingOrder',
                component: () => import('@/pages/bonded/outboundPlan/formPickingOrder/index.vue'),
                name: 'formPickingOrder',
                meta: { title: '拣货单' },
            },
            // 保税区管理-保税出仓业务交接单
            {
                path: 'formOutboundBill',
                component: () => import('@/pages/bonded/outboundBill/formOutboundBill/index.vue'),
                name: 'formOutboundBill',
                meta: { title: '保税出仓业务单' },
            },
            {
                path: 'formEditOutboundBill',
                component: () => import('@/pages/bonded/outboundBill/formEditOutboundBill/index.vue'),
                name: 'formEditOutboundBill',
                meta: { title: '保税出仓业务单' },
            },
            {
                path: 'formEntInfo',
                component: () => import('@/pages/cr/entinfo/formEntInfo/index.vue'),
                name: 'formEntInfo',
                meta: { title: '企业信息管理' },
            },
            {
                path: 'formApiKey',
                component: () => import('@/pages/upms/formApiKey/index.vue'),
                name: 'formApiKey',
                meta: { title: 'API Key管理' },
            },
            {
                path: 'formPrintTemplate',
                component: () => import('@/pages/upms/formPrintTemplate/formPrintTemplate/index.vue'),
                name: 'formPrintTemplate',
                meta: { title: '打印模板管理' },
            },
            {
                path: 'formCustomsBroker',
                component: () => import('@/pages/decl/formCustomsBroker/index.vue'),
                name: 'formCustomsBroker',
                meta: { title: '报关企业管理' },
            },
            // 404
            {
                path: '/:pathMatch(.*)*',
                component: () => import('@/pages/error/404.vue'),
                name: 'NotFound',
                meta: {
                    title: '404',
                },
            },
        ],
    },
];
